import { useNavigate } from "react-router-dom"
import { JobbinInputWhite } from "../jobbinInputWhite"
import { SearchBarProps } from "./model"

export const SearchBar = (props: SearchBarProps) => {
    const navigate = useNavigate()
    return (
        <div className="flex w-full flex-col gap-4 md:grid md:grid-cols-12 md:gap-6">
            <div className="w-full md:col-span-8 lg:col-span-9">
                <JobbinInputWhite
                    onChange={props.onChange}
                    classNames="bg-figmaLightBg text-[14px]"
                    type="text"
                    name="search"
                    placeholder={props.text}
                    iconEnd="search-icon.svg"
                />
            </div>

            <button
                className="jobbin-primary-button flex w-full items-center justify-center gap-2 rounded-[12px] bg-figmaPrimary px-6 py-3 text-figmaWhite md:col-span-4 lg:col-span-3"
                type="button"
                onClick={() => navigate("/post-job")}
            >
                <img src="/images/add-circle-white.svg" alt="Adaugă" className="h-5 w-5" />
                <span className="text-sm sm:text-base">Adaugă job</span>
            </button>
        </div>
    )
}